const emptyTypeState = () => ({ rows: {}, type: [] });

export const knowledgeValidationsResetState = (get) => ({
  knowledgeValidations: {},
  knowledgeValidationsGeneration: get().knowledgeValidationsGeneration + 1
});

const createKnowledgeValidationsSlice = (set, get) => ({
  knowledgeValidations: {},
  knowledgeValidationsGeneration: 0,
  applyKnowledgeValidationScopes: (scopes, { authoritative = false } = {}) => {
    if (!scopes?.length && !authoritative) {
      set({ knowledgeValidationsGeneration: get().knowledgeValidationsGeneration + 1 });
      return;
    }
    const next = { ...get().knowledgeValidations };
    const preparedTypes = new Set();
    const entryFor = (schemaType) => {
      if (!preparedTypes.has(schemaType)) {
        preparedTypes.add(schemaType);
        const current = (authoritative ? null : next[schemaType]) ?? emptyTypeState();
        next[schemaType] = { rows: { ...current.rows }, type: current.type };
      }
      return next[schemaType];
    };
    (scopes ?? []).forEach(({ schema_type, pk, errors }) => {
      const entry = entryFor(schema_type);
      if (pk === null || pk === undefined) {
        entry.type = errors ?? [];
      } else if (!errors?.length) {
        delete entry.rows[pk];
      } else {
        entry.rows[pk] = errors;
      }
    });
    set({ knowledgeValidations: next, knowledgeValidationsGeneration: get().knowledgeValidationsGeneration + 1 });
  },
  setAllKnowledgeValidations: (scopes, { ifGeneration } = {}) => {
    if (ifGeneration !== undefined && ifGeneration !== get().knowledgeValidationsGeneration) {
      return false;
    }
    set({ knowledgeValidations: {} });
    get().applyKnowledgeValidationScopes(scopes);
    return true;
  }
});

export default createKnowledgeValidationsSlice;
